/* GENERATED from the original artifact template by
 * tools/convert-template.py. Structure and inline styles are the
 * artifact's; edits since generation are tracked in git. */
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import type { TerminalVals } from '@/lib/vals/terminal';

export function TerminalRoute({ v }: { v: TerminalVals }) {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100dvh',
          overflow: 'hidden',
          background: 'var(--wft-bg-0)',
          fontSize: 'var(--wft-cell)',
        }}
      >
        <header
          style={{
            display: 'flex',
            flex: 'none',
            alignItems: 'center',
            gap: '12px',
            height: '36px',
            padding: '0 12px',
            background: 'var(--wft-bg-sunk)',
            borderBottom: '1px solid var(--wft-line)',
          }}
        >
          <button
            type="button"
            onClick={v.toggleRail}
            aria-label="Toggle navigation rail"
            title="Collapse the rail (Ctrl+B)"
            style={{
              background: 'none',
              border: 'none',
              padding: '0',
              cursor: 'pointer',
              fontFamily: 'var(--wft-mono)',
              fontSize: '12px',
              color: 'var(--wft-ink-2)',
            }}
          >
            ▐▌
          </button>{' '}
          <Link
            to="/"
            title="Back to the site"
            style={{
              fontFamily: 'var(--wft-display)',
              fontSize: '11px',
              letterSpacing: '0.14em',
              color: 'var(--wft-ink-1)',
              flex: 'none',
            }}
          >
            World Finance Terminal
          </Link>{' '}
          <div style={{ flex: '1', minWidth: '0', position: 'relative' }}>
            <input
              value={v.cmd}
              onInput={v.onCmd}
              onKeyDown={v.onCmdKey}
              placeholder="Command — mnemonic or section name"
              aria-label="Command bar"
              style={{
                width: '100%',
                background: 'var(--wft-bg-3)',
                border: '1px solid var(--wft-line)',
                borderRadius: '3px',
                padding: '4px 9px',
                fontFamily: 'var(--wft-mono)',
                fontSize: '12px',
                color: 'var(--wft-ink-0)',
              }}
              className="wft-i8"
            />{' '}
            {v.hasMatches ? (
              <>
                <div
                  style={{
                    position: 'absolute',
                    top: '30px',
                    left: '0',
                    right: '0',
                    zIndex: '30',
                    background: 'var(--wft-bg-1)',
                    border: '1px solid var(--wft-line-hi)',
                    borderRadius: '3px',
                    boxShadow: 'var(--wft-shadow)',
                    overflow: 'hidden',
                  }}
                >
                  {(v.matches ?? []).map((m, mIndex) => (
                    <Fragment key={mIndex}>
                      <button
                        type="button"
                        onClick={m.go}
                        style={{
                          display: 'flex',
                          alignItems: 'baseline',
                          gap: '10px',
                          width: '100%',
                          textAlign: 'left',
                          background: 'none',
                          border: 'none',
                          borderBottom: '1px solid var(--wft-line)',
                          padding: '6px 10px',
                          cursor: 'pointer',
                        }}
                        className="wft-i6"
                      >
                        <span
                          style={{
                            fontFamily: 'var(--wft-mono)',
                            fontSize: '9.5px',
                            color: 'var(--wft-accent)',
                            width: '36px',
                          }}
                        >
                          {m.mnemonic}
                        </span>{' '}
                        <span
                          style={{
                            fontFamily: 'var(--wft-mono)',
                            fontSize: '12px',
                            color: 'var(--wft-ink-0)',
                          }}
                        >
                          {m.title}
                        </span>{' '}
                        <span
                          style={{
                            marginLeft: 'auto',
                            fontFamily: 'var(--wft-mono)',
                            fontSize: '9.5px',
                            color: 'var(--wft-ink-3)',
                          }}
                        >
                          {m.purpose}
                        </span>
                      </button>
                    </Fragment>
                  ))}
                </div>
              </>
            ) : null}
          </div>{' '}
          <div style={{ display: 'flex', flex: 'none', alignItems: 'center', gap: '10px' }}>
            <button
              type="button"
              onClick={v.cycleDensity}
              title="Density (Ctrl+Shift+D)"
              style={{
                background: 'none',
                border: 'none',
                padding: '0',
                cursor: 'pointer',
                fontFamily: 'var(--wft-mono)',
                fontSize: '10px',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'var(--wft-ink-2)',
              }}
            >
              {v.densityLabel}
            </button>{' '}
            <button
              type="button"
              onClick={v.toggleTheme}
              title="Theme (Ctrl+Shift+T)"
              style={{
                background: 'none',
                border: 'none',
                padding: '0',
                cursor: 'pointer',
                fontFamily: 'var(--wft-mono)',
                fontSize: '10px',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'var(--wft-ink-2)',
              }}
            >
              {v.themeLabel}
            </button>{' '}
            <Link
              to="/"
              onClick={v.signOut}
              title="Sign out"
              style={{
                border: '1px solid var(--wft-line)',
                borderRadius: '3px',
                padding: '3px 9px',
                fontFamily: 'var(--wft-mono)',
                fontSize: '10px',
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                color: 'var(--wft-ink-2)',
              }}
              className="wft-i9"
            >
              Sign out
            </Link>
          </div>
        </header>{' '}
        <div style={{ display: 'flex', flex: '1', minHeight: '0' }}>
          <nav
            aria-label="Sections"
            style={{
              flex: 'none',
              width: v.railWidth,
              overflowY: 'auto',
              overflowX: 'hidden',
              background: 'var(--wft-bg-sunk)',
              borderRight: '1px solid var(--wft-line)',
            }}
          >
            {(v.railGroups ?? []).map((g, gIndex) => (
              <Fragment key={gIndex}>
                <div style={{ paddingBottom: '4px' }}>
                  <div style={{ padding: '12px 12px 4px' }}>
                    <span
                      style={{
                        fontFamily: 'var(--wft-mono)',
                        fontSize: '10.5px',
                        letterSpacing: '0.09em',
                        textTransform: 'uppercase',
                        color: 'var(--wft-ink-3)',
                      }}
                    >
                      {g.label}
                    </span>
                  </div>{' '}
                  {(g.items ?? []).map((s, sIndex) => (
                    <Fragment key={sIndex}>
                      <button
                        type="button"
                        onClick={s.go}
                        title={s.tip}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          width: '100%',
                          textAlign: 'left',
                          cursor: 'pointer',
                          padding: '3px 12px',
                          border: 'none',
                          borderLeft: `2px solid ${s.edge}`,
                          background: s.bg,
                        }}
                        className="wft-i6"
                      >
                        <span
                          style={{
                            flex: 'none',
                            width: '30px',
                            fontFamily: 'var(--wft-mono)',
                            fontSize: '9.5px',
                            color: s.mnemonicColor,
                          }}
                        >
                          {s.mnemonic}
                        </span>{' '}
                        <span
                          style={{
                            fontFamily: 'var(--wft-mono)',
                            fontSize: 'var(--wft-cell)',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            color: s.titleColor,
                          }}
                        >
                          {s.title}
                        </span>{' '}
                        <span
                          style={{
                            marginLeft: 'auto',
                            fontFamily: 'var(--wft-mono)',
                            fontSize: '8.5px',
                            color: 'var(--wft-ink-3)',
                          }}
                        >
                          {s.nc}
                        </span>
                      </button>
                    </Fragment>
                  ))}
                </div>
              </Fragment>
            ))}
          </nav>{' '}
          <main
            style={{
              display: 'flex',
              flex: '1',
              minWidth: '0',
              minHeight: '0',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
            id="wft-main"
            tabIndex={-1}
          >
            <div
              style={{
                display: 'flex',
                flex: 'none',
                flexWrap: 'wrap',
                alignItems: 'baseline',
                gap: '12px',
                padding: '8px 12px',
                borderBottom: '1px solid var(--wft-line)',
              }}
            >
              <span
                style={{
                  fontFamily: 'var(--wft-mono)',
                  fontSize: '11px',
                  color: 'var(--wft-accent)',
                  border: '1px solid var(--wft-accent-bd)',
                  borderRadius: '3px',
                  padding: '1px 5px',
                }}
              >
                {v.current.mnemonic}
              </span>{' '}
              <h1
                style={{
                  fontFamily: 'var(--wft-display)',
                  fontWeight: '600',
                  fontSize: '15px',
                  margin: '0',
                  color: 'var(--wft-ink-0)',
                }}
              >
                {v.current.title}
              </h1>{' '}
              <span
                style={{
                  fontFamily: 'var(--wft-mono)',
                  fontSize: '10.5px',
                  color: 'var(--wft-ink-2)',
                }}
              >
                {v.current.purpose}
              </span>{' '}
              <span
                style={{
                  marginLeft: 'auto',
                  fontFamily: 'var(--wft-mono)',
                  fontSize: '9.5px',
                  letterSpacing: '0.08em',
                  textTransform: 'uppercase',
                  color: 'var(--wft-ink-3)',
                }}
              >
                {v.current.panelCount}
              </span>
            </div>{' '}
            <div
              style={{ flex: '1', minHeight: '0', overflow: 'auto', padding: 'var(--wft-gutter)' }}
              tabIndex={0}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))',
                  gridAutoRows: 'minmax(210px, auto)',
                  gap: 'var(--wft-gutter)',
                }}
              >
                {(v.current.panels ?? []).map((p, pIndex) => (
                  <Fragment key={pIndex}>
                    <section
                      aria-label={p.title}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: '0',
                        minHeight: '0',
                        background: 'var(--wft-bg-1)',
                        border: '1px solid var(--wft-line)',
                        borderRadius: '3px',
                        overflow: 'hidden',
                      }}
                    >
                      <header
                        style={{
                          display: 'flex',
                          flex: 'none',
                          alignItems: 'center',
                          gap: '8px',
                          height: 'var(--wft-panel-hdr-h)',
                          padding: '0 var(--wft-panel-pad)',
                          background: 'var(--wft-bg-sunk)',
                          borderBottom: '1px solid var(--wft-line)',
                        }}
                      >
                        <span
                          style={{
                            fontFamily: 'var(--wft-mono)',
                            fontSize: '9.5px',
                            color: 'var(--wft-ink-3)',
                          }}
                        >
                          {p.index}
                        </span>{' '}
                        <h2
                          style={{
                            fontFamily: 'var(--wft-mono)',
                            fontSize: '10.5px',
                            letterSpacing: '0.09em',
                            textTransform: 'uppercase',
                            color: 'var(--wft-ink-1)',
                            margin: '0',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {p.title}
                        </h2>{' '}
                        <span
                          style={{
                            marginLeft: 'auto',
                            display: 'flex',
                            flex: 'none',
                            alignItems: 'center',
                            gap: '6px',
                          }}
                        >
                          {(p.dots ?? []).map((d, dIndex) => (
                            <Fragment key={dIndex}>
                              <span
                                title={d.title}
                                style={{
                                  width: '6px',
                                  height: '6px',
                                  borderRadius: '50%',
                                  background: d.fill,
                                  boxShadow: d.ring,
                                  opacity: d.opacity,
                                }}
                              ></span>
                            </Fragment>
                          ))}{' '}
                          <span
                            style={{
                              fontFamily: 'var(--wft-mono)',
                              fontSize: '8.5px',
                              letterSpacing: '0.08em',
                              color: 'var(--wft-ink-3)',
                            }}
                          >
                            {p.stateLabel}
                          </span>
                        </span>
                      </header>{' '}
                      <div style={{ flex: '1', minHeight: '0', overflow: 'auto' }} tabIndex={0}>
                        {p.isSessions ? (
                          <>
                            <div style={{ padding: 'var(--wft-panel-pad)' }}>
                              {(v.sessions ?? []).map((s, sIndex) => (
                                <Fragment key={sIndex}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px',
                                      height: 'var(--wft-row-h)',
                                    }}
                                  >
                                    <span
                                      style={{
                                        width: '6px',
                                        height: '6px',
                                        borderRadius: '50%',
                                        background: s.color,
                                      }}
                                    ></span>{' '}
                                    <span
                                      style={{
                                        fontFamily: 'var(--wft-mono)',
                                        fontSize: 'var(--wft-cell)',
                                        color: 'var(--wft-ink-1)',
                                      }}
                                    >
                                      {s.city}
                                    </span>{' '}
                                    <span
                                      style={{
                                        marginLeft: 'auto',
                                        fontFamily: 'var(--wft-mono)',
                                        fontVariantNumeric: 'tabular-nums',
                                        fontSize: 'var(--wft-cell)',
                                        color: 'var(--wft-ink-0)',
                                      }}
                                    >
                                      {s.time}
                                    </span>{' '}
                                    <span
                                      style={{
                                        width: '54px',
                                        textAlign: 'right',
                                        fontFamily: 'var(--wft-mono)',
                                        fontSize: '9.5px',
                                        color: 'var(--wft-ink-3)',
                                      }}
                                    >
                                      {s.state}
                                    </span>
                                  </div>
                                </Fragment>
                              ))}{' '}
                              <p
                                style={{
                                  fontFamily: 'var(--wft-mono)',
                                  fontSize: '9.5px',
                                  lineHeight: '1.6',
                                  color: 'var(--wft-ink-3)',
                                  margin: '8px 0 0',
                                }}
                              >
                                Derived from the browser clock and exchange hours; no feed required.
                              </p>
                            </div>
                          </>
                        ) : null}{' '}
                        {p.isSources ? (
                          <>
                            <div style={{ padding: 'var(--wft-panel-pad)' }}>
                              {(v.sources ?? []).map((s, sIndex) => (
                                <Fragment key={sIndex}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '8px',
                                      height: 'var(--wft-row-h)',
                                    }}
                                  >
                                    <span
                                      style={{
                                        width: '6px',
                                        height: '6px',
                                        flex: 'none',
                                        borderRadius: '50%',
                                        boxShadow: 'inset 0 0 0 1px var(--wft-unbound)',
                                        opacity: '.6',
                                      }}
                                    ></span>{' '}
                                    <span
                                      style={{
                                        fontFamily: 'var(--wft-mono)',
                                        fontSize: 'var(--wft-cell)',
                                        color: 'var(--wft-ink-1)',
                                      }}
                                    >
                                      {s.label}
                                    </span>{' '}
                                    <span
                                      style={{
                                        marginLeft: 'auto',
                                        fontFamily: 'var(--wft-mono)',
                                        fontSize: '9.5px',
                                        color: 'var(--wft-unbound)',
                                      }}
                                    >
                                      unbound
                                    </span>{' '}
                                    <span
                                      style={{
                                        width: '46px',
                                        textAlign: 'right',
                                        fontFamily: 'var(--wft-mono)',
                                        fontVariantNumeric: 'tabular-nums',
                                        fontSize: '9.5px',
                                        color: 'var(--wft-ink-3)',
                                      }}
                                    >
                                      — ser
                                    </span>
                                  </div>
                                </Fragment>
                              ))}{' '}
                              <p
                                style={{
                                  fontFamily: 'var(--wft-mono)',
                                  fontSize: '9.5px',
                                  lineHeight: '1.6',
                                  color: 'var(--wft-ink-3)',
                                  margin: '8px 0 0',
                                }}
                              >
                                The API at :8110 is not reachable from this demo, so every connector
                                reports unbound rather than a colour it has not earned.
                              </p>
                            </div>
                          </>
                        ) : null}{' '}
                        {p.isNC ? (
                          <>
                            <div
                              style={{
                                height: '100%',
                                minHeight: '90px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '14px',
                                backgroundImage:
                                  'repeating-linear-gradient(45deg, transparent 0 5px, var(--wft-line) 5px 6px)',
                              }}
                            >
                              <div
                                style={{
                                  maxWidth: '360px',
                                  background: 'var(--wft-bg-1)',
                                  border: '1px solid var(--wft-line-hi)',
                                  borderRadius: '3px',
                                  padding: '10px 12px',
                                }}
                              >
                                <p
                                  style={{
                                    fontFamily: 'var(--wft-mono)',
                                    fontSize: '10.5px',
                                    letterSpacing: '0.09em',
                                    textTransform: 'uppercase',
                                    color: 'var(--wft-ink-2)',
                                    margin: '0',
                                  }}
                                >
                                  Not connected
                                </p>{' '}
                                <p
                                  style={{
                                    fontSize: 'var(--wft-cell)',
                                    lineHeight: '1.45',
                                    color: 'var(--wft-ink-1)',
                                    margin: '6px 0 0',
                                  }}
                                >
                                  {p.ncLine}
                                </p>{' '}
                                <p
                                  style={{
                                    fontFamily: 'var(--wft-mono)',
                                    fontSize: '9.5px',
                                    lineHeight: '1.6',
                                    color: 'var(--wft-ink-2)',
                                    margin: '5px 0 0',
                                  }}
                                >
                                  {p.needsLine}
                                </p>{' '}
                                <p
                                  style={{
                                    fontFamily: 'var(--wft-mono)',
                                    fontSize: '9.5px',
                                    lineHeight: '1.6',
                                    color: 'var(--wft-ink-3)',
                                    margin: '8px 0 0',
                                    paddingTop: '7px',
                                    borderTop: '1px solid var(--wft-line)',
                                  }}
                                >
                                  {p.connector}
                                </p>
                              </div>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </section>
                  </Fragment>
                ))}
              </div>
            </div>
          </main>
        </div>{' '}
        <footer
          style={{
            display: 'flex',
            flex: 'none',
            alignItems: 'center',
            gap: '16px',
            height: '22px',
            padding: '0 12px',
            overflowX: 'auto',
            background: 'var(--wft-bg-sunk)',
            borderTop: '1px solid var(--wft-line)',
          }}
          tabIndex={0}
        >
          <span
            style={{
              flex: 'none',
              fontFamily: 'var(--wft-mono)',
              fontVariantNumeric: 'tabular-nums',
              fontSize: '9.5px',
              color: 'var(--wft-ink-1)',
            }}
          >
            {v.utc}
          </span>{' '}
          <div style={{ display: 'flex', flex: 'none', alignItems: 'center', gap: '12px' }}>
            {(v.sessions ?? []).map((s, sIndex) => (
              <Fragment key={sIndex}>
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  <span
                    style={{
                      width: '5px',
                      height: '5px',
                      borderRadius: '50%',
                      background: s.color,
                    }}
                  ></span>{' '}
                  <span
                    style={{
                      fontFamily: 'var(--wft-mono)',
                      fontSize: '9.5px',
                      color: 'var(--wft-ink-2)',
                    }}
                  >
                    {s.code}
                  </span>{' '}
                  <span
                    style={{
                      fontFamily: 'var(--wft-mono)',
                      fontVariantNumeric: 'tabular-nums',
                      fontSize: '9.5px',
                      color: 'var(--wft-ink-3)',
                    }}
                  >
                    {s.hm}
                  </span>
                </span>
              </Fragment>
            ))}
          </div>{' '}
          <span
            style={{
              marginLeft: 'auto',
              display: 'flex',
              flex: 'none',
              alignItems: 'center',
              gap: '12px',
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <span
                style={{
                  width: '5px',
                  height: '5px',
                  borderRadius: '50%',
                  boxShadow: 'inset 0 0 0 1px var(--wft-unbound)',
                  opacity: '.6',
                }}
              ></span>{' '}
              <span
                style={{
                  fontFamily: 'var(--wft-mono)',
                  fontSize: '9.5px',
                  color: 'var(--wft-ink-2)',
                }}
              >
                api not connected
              </span>
            </span>{' '}
            <span
              style={{
                fontFamily: 'var(--wft-mono)',
                fontSize: '9.5px',
                color: 'var(--wft-ink-3)',
              }}
            >
              wft 0.1.0
            </span>
          </span>
        </footer>
      </div>
    </>
  );
}
